<template>
  <div class="card-header border-bottom pt-1 pb-1">
    <h4 class="card-title">Products and Services</h4>
  </div>

  <div class="card-body mt-2">
    <form class="invoice-repeater" @submit.prevent="submit">
      <div>

        <div v-for="(item, index) in products" :key="index" class="row">
          <div class="col-md-3 col-12">
            <div class="mb-1">
              <AsyncSelect
                  placeholder="Select Product"
                  v-model="item.product"
                  :api-service="fetchProductList"
                  :additional-query="productQuery"
                  label="text"
                  :format-label="option => option.text"
                  @update:modelValue="val => item.product_id = val ? val.id : null"
              />
              <span v-if="errors[index] && errors[index].product_id" class="text-danger" style="font-size:12px;">
                {{ errors[index].product_id }}
              </span>
            </div>
          </div>

          <div class="col-md-2 col-12">
            <div class="mb-1">
              <input
                  v-model="item.rate"
                  type="number"
                  class="form-control"
                  placeholder="Rate"
                  min="0"
                  step="any"
              />
              <span v-if="errors[index] && errors[index].rate" class="text-danger" style="font-size:12px;">
                {{ errors[index].rate }}
              </span>
            </div>
          </div>

          <div class="col-md-3 col-12">
            <div class="mb-1">
              <input
                  v-model="item.effective_date"
                  type="date"
                  class="form-control"
              />
              <span v-if="errors[index] && errors[index].effective_date" class="text-danger" style="font-size:12px;">
                {{ errors[index].effective_date }}
              </span>
            </div>
          </div>

          <div class="col-md-3 col-12">
            <div class="mb-1">
              <input
                  v-model="item.remarks"
                  type="text"
                  class="form-control"
                  placeholder="Remarks (optional)"
              />
            </div>
          </div>

          <div class="col-md-1 col-12 p_left_0">

            <div class="mb-1 _skill_out_visibility">
              <button
                  v-if="products.length === (index + 1)"
                  @click="addMore"
                  class="btn btn-outline-primary text-nowrap px-1 button_icon"
                  type="button"
              >
               <i class="fa fa-plus"></i>
              </button>

              <button
                  v-else
                  @click="remove(index)"
                  class="btn btn-outline-danger text-nowrap px-1 button_icon"
                  type="button"
              >
                 <i class="fa fa-trash"></i>
              </button>
            </div>

            <div class="mb-1 d-grid gap-2 d-none _skill_btn_visibility">
              <button
                  v-if="products.length === (index + 1)"
                  @click="addMore"
                  class="btn btn-primary text-nowrap px-1 button_icon"
                  type="button"
              >
                <i class="fa fa-plus"></i>
              </button>

              <button
                  v-else
                  @click="remove(index)"
                  class="btn btn-danger text-nowrap px-1 button_icon"
                  type="button"
              >
                <i class="fa fa-trash"></i>
              </button>
            </div>

          </div>
        </div>

        <div class="row">
          <div class="col-sm-12">
            <button type="submit" class="btn btn-primary me-1">Submit</button>
            <button @click="reset" type="reset" class="btn btn-outline-secondary">Reset</button>
          </div>
        </div>

      </div>
    </form>
  </div>
</template>

<script setup>
import {defineProps, ref, watch} from "vue";
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import handlePurchaseAndSales from "@/services/modules/purchase";
import {useRoute} from "vue-router";

const props = defineProps({
  items: {
    type: Array,
    default: () => []
  }
})

const emit = defineEmits(['storeContact'])

const route = useRoute()
const {fetchProductList} = handlePurchaseAndSales()

const productQuery = {company_id: route.params.companyId}

const emptyRow = () => ({
  product_id: null,
  product: null,
  rate: '',
  effective_date: '',
  remarks: ''
})

const products = ref([emptyRow()])
const errors = ref([])

const addMore = () => {
  products.value.push(emptyRow())
  errors.value.push({})
}

const remove = (index) => {
  products.value.splice(index, 1)
  errors.value.splice(index, 1)
}

const reset = () => {
  products.value = [emptyRow()]
  errors.value = []
}

const validate = () => {
  let valid = true
  const seenIds = []
  errors.value = products.value.map(item => {
    const rowErrors = {}
    if (!item.product_id) rowErrors.product_id = 'Product is required'
    if (item.product_id && seenIds.includes(item.product_id)) rowErrors.product_id = 'Duplicate product is not allowed'
    if (item.product_id && !seenIds.includes(item.product_id)) seenIds.push(item.product_id)
    if (!item.rate && item.rate !== 0) rowErrors.rate = 'Rate is required'
    if (!item.effective_date) rowErrors.effective_date = 'Effective date is required'
    if (Object.keys(rowErrors).length) valid = false
    return rowErrors
  })
  return valid
}

const submit = () => {
  if (!validate()) return
  const items = products.value.map(item => ({
    ...(item.id ? {id: item.id} : {}),
    product_service: item.product_id,
    rate: item.rate,
    effective_date: item.effective_date,
    remarks: item.remarks
  }))
  emit('storeContact', {items})
}

watch(() => props.items, () => {
  formDataSet()
})

const formDataSet = () => {
  if (!props.items.length) return
  products.value = props.items.map(item => ({
    id: item.id,
    product_id: item.product_service ? Number(item.product_service) : null,
    product: item.product_service ? {id: Number(item.product_service), text: item.product_name ?? ''} : null,
    rate: item.rate ?? '',
    effective_date: item.effective_date ?? '',
    remarks: item.remarks ?? ''
  }))
  errors.value = []
}
</script>

<style scoped></style>
